import { lory } from "lory.js";

// Default image slider module
const sliders = document.querySelectorAll(".image-slider");
sliders.forEach((slider) => {
  lory(slider, {
    infinite: 1,
    ease: "ease-in-out",
    slideSpeed: 300,
    enableMouseEvents: true,
  });
});

// Front-page slider
const frontpage_slider = document.querySelector(".front-page__hero__slider");
if (frontpage_slider) {
  const lorySlider = lory(frontpage_slider, {
    infinite: 1,
    ease: "easeInOutCubic",
    slideSpeed: 500,
    enableMouseEvents: true,
  });
  setInterval(() => lorySlider.next(), 3500);
}
